module.exports = {
	"contractName": "FakeFibonacciFactory",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "previousOwner",
					"type": "address"
				},
				{
					"indexed": true,
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "OwnershipTransferred",
			"type": "event"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_player",
					"type": "address"
				}
			],
			"name": "createInstance",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": true,
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_instance",
					"type": "address"
				},
				{
					"name": "_player",
					"type": "address"
				}
			],
			"name": "validateInstance",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		}
	],
	"bytecode": "0x608060405260008054600160a060020a03191633179055610729806100256000396000f3006080604052600436106100615763ffffffff7c01000000000000000000000000000000000000000000000000000000006000350416637726f77681146100665780638da5cb5b14610096578063d38def5b146100ab578063f2fde38b146100e6575b600080fd5b61007a600160a060020a0360043516610109565b60408051600160a060020a039092168252519081900360200190f35b3480156100a257600080fd5b5061007a610191565b3480156100b757600080fd5b506100d2600160a060020a03600435811690602435166101a0565b604080519115158252519081900360200190f35b3480156100f257600080fd5b50610107600160a060020a03600435166101af565b005b60008080670de0b6b3a764000034101561012257600080fd5b61012a610243565b604051809103906000f080158015610146573d6000803e3d6000fd5b509150670de0b6b3a76400008261015b610253565b600160a060020a039091168152604051908190036020019082f080158015610187573d6000803e3d6000fd5b5095945050505050565b600054600160a060020a031681565b50600160a060020a0316311590565b600054600160a060020a031633146101c657600080fd5b600160a060020a03811615156101db57600080fd5b60008054604051600160a060020a03808516939216917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e091a36000805473ffffffffffffffffffffffffffffffffffffffff1916600160a060020a0392909216919091179055565b60405161019d8061026483390190565b6040516102fd80610401833901905600608060405234801561001057600080fd5b5061017d806100206000396000f3006080604052600436106100615763ffffffff7c0100000000000000000000000000000000000000000000000000000000600035041663bbe1d75b8114610066578063be9a65551461008d578063f6a03ebf146100a2578063fe75faab146100bc575b600080fd5b34801561007257600080fd5b5061007b6100d4565b60408051918252519081900360200190f35b34801561009957600080fd5b5061007b6100da565b3480156100ae57600080fd5b506100ba6004356100e0565b005b3480156100c857600080fd5b506100ba6004356100e5565b60015481565b60005481565b600055565b6100ee816100f4565b60015550565b6000811515610106575060005461014c565b816001141561011b575060005460010161014c565b8160021415610130575060005460020161014c565b61013c600383036100f4565b610148600184036100f4565b0190505b9190505600a165627a7a72305820864baad3654c31c8c20ffef2c7f53c23c68e3d5ff831b204fbd9ab5b834421270029608060405260036002556040516020806102fd833981016040525160008054600160a060020a03909216600160a060020a03199092169190911790556102b38061004a6000396000f30060806040526004361061006c5763ffffffff7c010000000000000000000000000000000000000000000000000000000060003504166320d786b581146100c85780633ccfd60b146100ef578063bbe1d75b14610104578063be9a655514610119578063fb582c2d1461012e575b34801561007857600080fd5b506000805460405173ffffffffffffffffffffffffffffffffffffffff9091169190369080838380828437820191505092505050600060405180830381855af491505015156100c657600080fd5b005b3480156100d457600080fd5b506100dd61016c565b60408051918252519081900360200190f35b3480156100fb57600080fd5b506100c6610172565b34801561011057600080fd5b506100dd61025f565b34801561012557600080fd5b506100dd610265565b34801561013a57600080fd5b5061014361026b565b6040805173ffffffffffffffffffffffffffffffffffffffff9092168252519081900360200190f35b60035481565b600380546001019081905560008054604080517f7365744669626f6e616363692875696e743235362900000000000000000000008152815190819003601501812063ffffffff7c01000000000000000000000000000000000000000000000000000000009182900490811690910282526004820195909552905173ffffffffffffffffffffffffffffffffffffffff909216939260248083019391928290030181865af492505050151561022557600080fd5b600154604051339166038d7ea4c680000280156108fc02916000818181858888f1935050505015801561025c573d6000803e3d6000fd5b50565b60015481565b60025481565b60005473ffffffffffffffffffffffffffffffffffffffff16815600a165627a7a723058209542befcf07c511b2c59c8670d9cdf8973527cdc37cd4001106e736bca78621d0029a165627a7a72305820dd0a77623f85e421770edccdde2951d650e1e62d68444ab4d1934c63debac95b0029",
	"deployedBytecode": "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",
	"sourceMap": "88:495:10:-;;;501:5:29;:18;;-1:-1:-1;;;;;;501:18:29;509:10;501:18;;;88:495:10;;;;;;",
	"deployedSourceMap": "88:495:10:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;131:290;;-1:-1:-1;;;;;131:290:10;;;;;;;;;-1:-1:-1;;;;;131:290:10;;;;;;;;;;;;;;238:20:29;;8:9:-1;5:2;;;30:1;27;20:12;5:2;238:20:29;;;;425:156:10;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;425:156:10;-1:-1:-1;;;;;425:156:10;;;;;;;;;;;;;;;;;;;;;;;;;;;;832:169:29;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;832:169:29;-1:-1:-1;;;;;832:169:29;;;;;;;131:290:10;196:7;;;245;232:9;:20;;224:29;;;;;;282:22;;:::i;:::-;;;;;;;;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;282:22:10;259:45;;365:7;389:3;335:64;;:::i;:::-;-1:-1:-1;;;;;335:64:10;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;-1:-1;335:64:10;131:290;-1:-1:-1;;;;;131:290:10:o;238:20:29:-;;;-1:-1:-1;;;;;238:20:29;;:::o;425:156:10:-;-1:-1:-1;;;;;;545:26:10;;:31;;425:156::o;832:169:29:-;653:5;;-1:-1:-1;;;;;653:5:29;639:10;:19;631:28;;;;;;-1:-1:-1;;;;;908:22:29;;;;900:31;;;;;;958:5;;;937:37;;-1:-1:-1;;;;;937:37:29;;;;958:5;;;937:37;;;980:5;:16;;-1:-1:-1;;980:16:29;-1:-1:-1;;;;;980:16:29;;;;;;;;;;832:169::o;88:495:10:-;;;;;;;;;;:::o;:::-;;;;;;;;;;:::o",
	"source": "pragma solidity ^0.4.24;\n\nimport \"./base/Level.sol\";\nimport \"./FakeFibonacciBank.sol\";\n\ncontract FakeFibonacciFactory is Level {\n  function createInstance(address _player) public payable returns (address) {\n    _player;\n    require(msg.value >= 1 ether);\n    FakeFibonacciLib lib = new FakeFibonacciLib();\n    FakeFibonacciBank bank = (new FakeFibonacciBank).value(1 ether)(\n      address(lib)\n    );\n    return bank;\n  }\n\n  function validateInstance(address _instance, address _player)\n    public\n    returns (bool)\n  {\n    _player;\n    return address(_instance).balance == 0;\n  }\n}\n",
	"sourcePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/FakeFibonacciFactory.sol",
	"ast": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/FakeFibonacciFactory.sol",
		"exportedSymbols": {
			"FakeFibonacciFactory": [
				1236
			]
		},
		"id": 1237,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 1174,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:10"
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
				"file": "./base/Level.sol",
				"id": 1175,
				"nodeType": "ImportDirective",
				"scope": 1237,
				"sourceUnit": 2867,
				"src": "26:26:10",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/FakeFibonacciBank.sol",
				"file": "./FakeFibonacciBank.sol",
				"id": 1176,
				"nodeType": "ImportDirective",
				"scope": 1237,
				"sourceUnit": 1173,
				"src": "53:33:10",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 1177,
							"name": "Level",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2866,
							"src": "121:5:10",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Level_$2866",
								"typeString": "contract Level"
							}
						},
						"id": 1178,
						"nodeType": "InheritanceSpecifier",
						"src": "121:5:10"
					}
				],
				"contractDependencies": [
					1107,
					1172,
					2866,
					2922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 1236,
				"linearizedBaseContracts": [
					1236,
					2866,
					2922
				],
				"name": "FakeFibonacciFactory",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"body": {
							"id": 1215,
							"nodeType": "Block",
							"src": "205:216:10",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1185,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1180,
										"src": "211:7:10",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 1186,
									"nodeType": "ExpressionStatement",
									"src": "211:7:10"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 1191,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1188,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2937,
														"src": "232:3:10",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 1189,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "value",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "232:9:10",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">=",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 1190,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "245:7:10",
													"subdenomination": "ether",
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1000000000000000000_by_1",
														"typeString": "int_const 1000000000000000000"
													},
													"value": "1"
												},
												"src": "232:20:10",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 1187,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "224:7:10",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 1192,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "224:29:10",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1193,
									"nodeType": "ExpressionStatement",
									"src": "224:29:10"
								},
								{
									"assignments": [
										1195
									],
									"declarations": [
										{
											"constant": false,
											"id": 1195,
											"name": "lib",
											"nodeType": "VariableDeclaration",
											"scope": 1216,
											"src": "259:20:10",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_FakeFibonacciLib_$1107",
												"typeString": "contract FakeFibonacciLib"
											},
											"typeName": {
												"contractScope": null,
												"id": 1194,
												"name": "FakeFibonacciLib",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 1107,
												"src": "259:16:10",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_FakeFibonacciLib_$1107",
													"typeString": "contract FakeFibonacciLib"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1199,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"id": 1197,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "NewExpression",
											"src": "282:20:10",
											"typeDescriptions": {
												"typeIdentifier": "t_function_creation_nonpayable$__$returns$_t_contract$_FakeFibonacciLib_$1107_$",
												"typeString": "function () returns (contract FakeFibonacciLib)"
											},
											"typeName": {
												"contractScope": null,
												"id": 1196,
												"name": "FakeFibonacciLib",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 1107,
												"src": "286:16:10",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_FakeFibonacciLib_$1107",
													"typeString": "contract FakeFibonacciLib"
												}
											}
										},
										"id": 1198,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "282:22:10",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_FakeFibonacciLib_$1107",
											"typeString": "contract FakeFibonacciLib"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "259:45:10"
								},
								{
									"assignments": [
										1201
									],
									"declarations": [
										{
											"constant": false,
											"id": 1201,
											"name": "bank",
											"nodeType": "VariableDeclaration",
											"scope": 1216,
											"src": "310:22:10",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_FakeFibonacciBank_$1172",
												"typeString": "contract FakeFibonacciBank"
											},
											"typeName": {
												"contractScope": null,
												"id": 1200,
												"name": "FakeFibonacciBank",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 1172,
												"src": "310:17:10",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_FakeFibonacciBank_$1172",
													"typeString": "contract FakeFibonacciBank"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1212,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"id": 1209,
														"name": "lib",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1195,
														"src": "389:3:10",
														"typeDescriptions": {
															"typeIdentifier": "t_contract$_FakeFibonacciLib_$1107",
															"typeString": "contract FakeFibonacciLib"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_contract$_FakeFibonacciLib_$1107",
															"typeString": "contract FakeFibonacciLib"
														}
													],
													"id": 1208,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "381:7:10",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_address_$",
														"typeString": "type(address)"
													},
													"typeName": "address"
												},
												"id": 1210,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "381:12:10",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"arguments": [
												{
													"argumentTypes": null,
													"hexValue": "31",
													"id": 1206,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "365:7:10",
													"subdenomination": "ether",
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1000000000000000000_by_1",
														"typeString": "int_const 1000000000000000000"
													},
													"value": "1"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_rational_1000000000000000000_by_1",
														"typeString": "int_const 1000000000000000000"
													}
												],
												"expression": {
													"argumentTypes": null,
													"components": [
														{
															"argumentTypes": null,
															"id": 1203,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "NewExpression",
															"src": "336:21:10",
															"typeDescriptions": {
																"typeIdentifier": "t_function_creation_payable$_t_address_$returns$_t_contract$_FakeFibonacciBank_$1172_$",
																"typeString": "function (address) payable returns (contract FakeFibonacciBank)"
															},
															"typeName": {
																"contractScope": null,
																"id": 1202,
																"name": "FakeFibonacciBank",
																"nodeType": "UserDefinedTypeName",
																"referencedDeclaration": 1172,
																"src": "340:17:10",
																"typeDescriptions": {
																	"typeIdentifier": "t_contract$_FakeFibonacciBank_$1172",
																	"typeString": "contract FakeFibonacciBank"
																}
															}
														}
													],
													"id": 1204,
													"isConstant": false,
													"isInlineArray": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "TupleExpression",
													"src": "335:23:10",
													"typeDescriptions": {
														"typeIdentifier": "t_function_creation_payable$_t_address_$returns$_t_contract$_FakeFibonacciBank_$1172_$",
														"typeString": "function (address) payable returns (contract FakeFibonacciBank)"
													}
												},
												"id": 1205,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "value",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "335:29:10",
												"typeDescriptions": {
													"typeIdentifier": "t_function_setvalue_nonpayable$_t_uint256_$returns$_t_function_creation_payable$_t_address_$returns$_t_contract$_FakeFibonacciBank_$1172_$value_$",
													"typeString": "function (uint256) returns (function (address) payable returns (contract FakeFibonacciBank))"
												}
											},
											"id": 1207,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "335:38:10",
											"typeDescriptions": {
												"typeIdentifier": "t_function_creation_payable$_t_address_$returns$_t_contract$_FakeFibonacciBank_$1172_$value",
												"typeString": "function (address) payable returns (contract FakeFibonacciBank)"
											}
										},
										"id": 1211,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "335:64:10",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_FakeFibonacciBank_$1172",
											"typeString": "contract FakeFibonacciBank"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "310:89:10"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1213,
										"name": "bank",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1201,
										"src": "412:4:10",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_FakeFibonacciBank_$1172",
											"typeString": "contract FakeFibonacciBank"
										}
									},
									"functionReturnParameters": 1184,
									"id": 1214,
									"nodeType": "Return",
									"src": "405:11:10"
								}
							]
						},
						"documentation": null,
						"id": 1216,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "createInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1181,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1180,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 1216,
									"src": "155:15:10",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1179,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "155:7:10",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "154:17:10"
						},
						"payable": true,
						"returnParameters": {
							"id": 1184,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1183,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1216,
									"src": "196:7:10",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1182,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "196:7:10",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "195:9:10"
						},
						"scope": 1236,
						"src": "131:290:10",
						"stateMutability": "payable",
						"superFunction": 2856,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1234,
							"nodeType": "Block",
							"src": "519:62:10",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1225,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1220,
										"src": "525:7:10",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 1226,
									"nodeType": "ExpressionStatement",
									"src": "525:7:10"
								},
								{
									"expression": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 1232,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"id": 1228,
														"name": "_instance",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1218,
														"src": "553:9:10",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													],
													"id": 1227,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "545:7:10",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_address_$",
														"typeString": "type(address)"
													},
													"typeName": "address"
												},
												"id": 1229,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "545:18:10",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"id": 1230,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "balance",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "545:26:10",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1231,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "575:1:10",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "545:31:10",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 1224,
									"id": 1233,
									"nodeType": "Return",
									"src": "538:38:10"
								}
							]
						},
						"documentation": null,
						"id": 1235,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "validateInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1221,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1218,
									"name": "_instance",
									"nodeType": "VariableDeclaration",
									"scope": 1235,
									"src": "451:17:10",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1217,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "451:7:10",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1220,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 1235,
									"src": "470:15:10",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1219,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "470:7:10",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "450:36:10"
						},
						"payable": false,
						"returnParameters": {
							"id": 1224,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1223,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1235,
									"src": "511:4:10",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 1222,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "511:4:10",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "510:6:10"
						},
						"scope": 1236,
						"src": "425:156:10",
						"stateMutability": "nonpayable",
						"superFunction": 2865,
						"visibility": "public"
					}
				],
				"scope": 1237,
				"src": "88:495:10"
			}
		],
		"src": "0:584:10"
	},
	"legacyAST": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/FakeFibonacciFactory.sol",
		"exportedSymbols": {
			"FakeFibonacciFactory": [
				1236
			]
		},
		"id": 1237,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 1174,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:10"
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
				"file": "./base/Level.sol",
				"id": 1175,
				"nodeType": "ImportDirective",
				"scope": 1237,
				"sourceUnit": 2867,
				"src": "26:26:10",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/FakeFibonacciBank.sol",
				"file": "./FakeFibonacciBank.sol",
				"id": 1176,
				"nodeType": "ImportDirective",
				"scope": 1237,
				"sourceUnit": 1173,
				"src": "53:33:10",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 1177,
							"name": "Level",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2866,
							"src": "121:5:10",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Level_$2866",
								"typeString": "contract Level"
							}
						},
						"id": 1178,
						"nodeType": "InheritanceSpecifier",
						"src": "121:5:10"
					}
				],
				"contractDependencies": [
					1107,
					1172,
					2866,
					2922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 1236,
				"linearizedBaseContracts": [
					1236,
					2866,
					2922
				],
				"name": "FakeFibonacciFactory",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"body": {
							"id": 1215,
							"nodeType": "Block",
							"src": "205:216:10",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1185,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1180,
										"src": "211:7:10",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 1186,
									"nodeType": "ExpressionStatement",
									"src": "211:7:10"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 1191,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1188,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2937,
														"src": "232:3:10",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 1189,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "value",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "232:9:10",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">=",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 1190,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "245:7:10",
													"subdenomination": "ether",
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1000000000000000000_by_1",
														"typeString": "int_const 1000000000000000000"
													},
													"value": "1"
												},
												"src": "232:20:10",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 1187,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "224:7:10",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 1192,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "224:29:10",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1193,
									"nodeType": "ExpressionStatement",
									"src": "224:29:10"
								},
								{
									"assignments": [
										1195
									],
									"declarations": [
										{
											"constant": false,
											"id": 1195,
											"name": "lib",
											"nodeType": "VariableDeclaration",
											"scope": 1216,
											"src": "259:20:10",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_FakeFibonacciLib_$1107",
												"typeString": "contract FakeFibonacciLib"
											},
											"typeName": {
												"contractScope": null,
												"id": 1194,
												"name": "FakeFibonacciLib",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 1107,
												"src": "259:16:10",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_FakeFibonacciLib_$1107",
													"typeString": "contract FakeFibonacciLib"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1199,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"id": 1197,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "NewExpression",
											"src": "282:20:10",
											"typeDescriptions": {
												"typeIdentifier": "t_function_creation_nonpayable$__$returns$_t_contract$_FakeFibonacciLib_$1107_$",
												"typeString": "function () returns (contract FakeFibonacciLib)"
											},
											"typeName": {
												"contractScope": null,
												"id": 1196,
												"name": "FakeFibonacciLib",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 1107,
												"src": "286:16:10",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_FakeFibonacciLib_$1107",
													"typeString": "contract FakeFibonacciLib"
												}
											}
										},
										"id": 1198,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "282:22:10",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_FakeFibonacciLib_$1107",
											"typeString": "contract FakeFibonacciLib"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "259:45:10"
								},
								{
									"assignments": [
										1201
									],
									"declarations": [
										{
											"constant": false,
											"id": 1201,
											"name": "bank",
											"nodeType": "VariableDeclaration",
											"scope": 1216,
											"src": "310:22:10",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_FakeFibonacciBank_$1172",
												"typeString": "contract FakeFibonacciBank"
											},
											"typeName": {
												"contractScope": null,
												"id": 1200,
												"name": "FakeFibonacciBank",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 1172,
												"src": "310:17:10",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_FakeFibonacciBank_$1172",
													"typeString": "contract FakeFibonacciBank"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1212,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"id": 1209,
														"name": "lib",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1195,
														"src": "389:3:10",
														"typeDescriptions": {
															"typeIdentifier": "t_contract$_FakeFibonacciLib_$1107",
															"typeString": "contract FakeFibonacciLib"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_contract$_FakeFibonacciLib_$1107",
															"typeString": "contract FakeFibonacciLib"
														}
													],
													"id": 1208,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "381:7:10",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_address_$",
														"typeString": "type(address)"
													},
													"typeName": "address"
												},
												"id": 1210,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "381:12:10",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"arguments": [
												{
													"argumentTypes": null,
													"hexValue": "31",
													"id": 1206,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "365:7:10",
													"subdenomination": "ether",
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1000000000000000000_by_1",
														"typeString": "int_const 1000000000000000000"
													},
													"value": "1"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_rational_1000000000000000000_by_1",
														"typeString": "int_const 1000000000000000000"
													}
												],
												"expression": {
													"argumentTypes": null,
													"components": [
														{
															"argumentTypes": null,
															"id": 1203,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "NewExpression",
															"src": "336:21:10",
															"typeDescriptions": {
																"typeIdentifier": "t_function_creation_payable$_t_address_$returns$_t_contract$_FakeFibonacciBank_$1172_$",
																"typeString": "function (address) payable returns (contract FakeFibonacciBank)"
															},
															"typeName": {
																"contractScope": null,
																"id": 1202,
																"name": "FakeFibonacciBank",
																"nodeType": "UserDefinedTypeName",
																"referencedDeclaration": 1172,
																"src": "340:17:10",
																"typeDescriptions": {
																	"typeIdentifier": "t_contract$_FakeFibonacciBank_$1172",
																	"typeString": "contract FakeFibonacciBank"
																}
															}
														}
													],
													"id": 1204,
													"isConstant": false,
													"isInlineArray": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "TupleExpression",
													"src": "335:23:10",
													"typeDescriptions": {
														"typeIdentifier": "t_function_creation_payable$_t_address_$returns$_t_contract$_FakeFibonacciBank_$1172_$",
														"typeString": "function (address) payable returns (contract FakeFibonacciBank)"
													}
												},
												"id": 1205,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "value",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "335:29:10",
												"typeDescriptions": {
													"typeIdentifier": "t_function_setvalue_nonpayable$_t_uint256_$returns$_t_function_creation_payable$_t_address_$returns$_t_contract$_FakeFibonacciBank_$1172_$value_$",
													"typeString": "function (uint256) returns (function (address) payable returns (contract FakeFibonacciBank))"
												}
											},
											"id": 1207,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "335:38:10",
											"typeDescriptions": {
												"typeIdentifier": "t_function_creation_payable$_t_address_$returns$_t_contract$_FakeFibonacciBank_$1172_$value",
												"typeString": "function (address) payable returns (contract FakeFibonacciBank)"
											}
										},
										"id": 1211,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "335:64:10",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_FakeFibonacciBank_$1172",
											"typeString": "contract FakeFibonacciBank"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "310:89:10"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1213,
										"name": "bank",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1201,
										"src": "412:4:10",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_FakeFibonacciBank_$1172",
											"typeString": "contract FakeFibonacciBank"
										}
									},
									"functionReturnParameters": 1184,
									"id": 1214,
									"nodeType": "Return",
									"src": "405:11:10"
								}
							]
						},
						"documentation": null,
						"id": 1216,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "createInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1181,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1180,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 1216,
									"src": "155:15:10",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1179,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "155:7:10",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "154:17:10"
						},
						"payable": true,
						"returnParameters": {
							"id": 1184,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1183,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1216,
									"src": "196:7:10",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1182,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "196:7:10",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "195:9:10"
						},
						"scope": 1236,
						"src": "131:290:10",
						"stateMutability": "payable",
						"superFunction": 2856,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1234,
							"nodeType": "Block",
							"src": "519:62:10",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1225,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1220,
										"src": "525:7:10",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 1226,
									"nodeType": "ExpressionStatement",
									"src": "525:7:10"
								},
								{
									"expression": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 1232,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"id": 1228,
														"name": "_instance",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1218,
														"src": "553:9:10",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													],
													"id": 1227,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "545:7:10",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_address_$",
														"typeString": "type(address)"
													},
													"typeName": "address"
												},
												"id": 1229,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "545:18:10",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"id": 1230,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "balance",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "545:26:10",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1231,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "575:1:10",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "545:31:10",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 1224,
									"id": 1233,
									"nodeType": "Return",
									"src": "538:38:10"
								}
							]
						},
						"documentation": null,
						"id": 1235,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "validateInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1221,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1218,
									"name": "_instance",
									"nodeType": "VariableDeclaration",
									"scope": 1235,
									"src": "451:17:10",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1217,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "451:7:10",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1220,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 1235,
									"src": "470:15:10",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1219,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "470:7:10",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "450:36:10"
						},
						"payable": false,
						"returnParameters": {
							"id": 1224,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1223,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1235,
									"src": "511:4:10",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 1222,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "511:4:10",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "510:6:10"
						},
						"scope": 1236,
						"src": "425:156:10",
						"stateMutability": "nonpayable",
						"superFunction": 2865,
						"visibility": "public"
					}
				],
				"scope": 1237,
				"src": "88:495:10"
			}
		],
		"src": "0:584:10"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {},
	"schemaVersion": "2.0.1",
	"updatedAt": "2020-10-22T15:28:26.801Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/FakeFibonacciFactory.json
// module id = 1035
// module chunks = 0